import React from 'react';
import { AssetContext, AssetContextProps } from '../context/AssetContext';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';
import { Asset } from '../types/asset/asset';

const assetState = {
  items: new Map<string, Asset>(),
  loading: false,
};

export const assetSlice = createSlice({
  name: 'asset',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      assetState.items = new Map();
      assetState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<Asset[]>) => {
      assetState.items = new Map();
      action.payload.forEach(p => assetState.items.set(p.id, new Asset(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<Asset[]>) => {
      action.payload.forEach(p => assetState.items.set(p.id, new Asset(p)));
      assetState.items = new Map(assetState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<Asset[]>) => {
      action.payload.forEach(p => assetState.items.delete(p.id));
      assetState.items = new Map(assetState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      assetState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface AssetProviderProps {
  children: React.ReactNode;
}

export default function AssetProvider({ children }: AssetProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.assets.key);

  const assetContext: AssetContextProps = {
    assets: assetState.items,
    assetsLoading: assetState.loading,
    setAssets: (asset: Map<string, Asset>) => {
      dispatch(assetSlice.actions.set([...asset.values()]));
    },
  };

  return <AssetContext.Provider value={assetContext}>{children}</AssetContext.Provider>;
}
